import React, { Fragment } from "react";
import Navbar from "./components/nav/Navbar";

const Page = ({ children }) => {
  return (
    <Fragment>
      <Navbar />
      {children}
    </Fragment>
  );
};

export default Page;
